import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-[#0f1419] py-16 md:py-24 px-4" data-id="element-140">
      <div className="max-w-4xl mx-auto" data-id="element-141">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8edf4] mb-8 text-center" data-id="element-142">
          Cuando apagas la luz… empieza el ruido
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-[#d1d9e6] leading-relaxed" data-id="element-143">
          <p data-id="element-144">Te acuestas. Cierras los ojos.</p>

          <p data-id="element-145">Y de repente tu mente hace inventario:</p>

          <ul className="space-y-3 ml-6" data-id="element-146">
            <li className="flex items-start" data-id="element-147">
              <span className="text-[#a8b5d1] mr-3 mt-1" data-id="element-148">•</span>
              <span data-id="element-149">lo que no has hecho</span>
            </li>
            <li className="flex items-start" data-id="element-150">
              <span className="text-[#a8b5d1] mr-3 mt-1" data-id="element-151">•</span>
              <span data-id="element-152">lo que te preocupa</span>
            </li>
            <li className="flex items-start" data-id="element-153">
              <span className="text-[#a8b5d1] mr-3 mt-1" data-id="element-154">•</span>
              <span data-id="element-155">lo que dijiste y te arrepientes</span>
            </li>
            <li className="flex items-start" data-id="element-156">
              <span className="text-[#a8b5d1] mr-3 mt-1" data-id="element-157">•</span>
              <span data-id="element-158">lo que "podría pasar"</span>
            </li>
            <li className="flex items-start" data-id="element-159">
              <span className="text-[#a8b5d1] mr-3 mt-1" data-id="element-160">•</span>
              <span data-id="element-161">lo que te falta para sentirte tranquila</span>
            </li>
          </ul>

          <p data-id="element-162">
            Y tu cuerpo responde: pecho apretado, garganta, corazón rápido,
            incomodidad.
          </p>

          <blockquote className="border-l-4 border-[#a8b5d1] pl-6 py-4 my-8 bg-[#1e2738] rounded-r-lg ring-1 ring-white/5" data-id="element-163">
            <p className="italic text-2xl md:text-3xl text-[#e8edf4] font-serif" data-id="element-164">
              Ahí nace el miedo secreto: "¿y si hoy tampoco puedo dormir?"
            </p>
          </blockquote>

          <p className="text-xl md:text-2xl font-medium text-[#e8edf4]" data-id="element-165">
            Ese miedo es gasolina. Y la noche se vuelve una pelea.
          </p>
        </div>
      </div>
    </section>;
}